import { render, staticRenderFns } from "./LetsGoDestinations.vue?vue&type=template&id=2f11ed84&scoped=true&"
import script from "./LetsGoDestinations.vue?vue&type=script&lang=js&"
export * from "./LetsGoDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11ed84",
  null
  
)

export default component.exports